import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.STOREFRONT_SUPABASE_URL ?? 'http://localhost:54421';
const SUPABASE_ANON_KEY =
  import.meta.env.STOREFRONT_SUPABASE_ANON_KEY ??
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlLWRlbW8iLCJpYXQiOjE2NDE3NjkyMDAsImV4cCI6MTc5OTUzNTYwMH0.dc_X5iR_VP_qT0zsiyj_I_OZ2T9FtRU2BBNWN8Bu4GE';

if (!import.meta.env.STOREFRONT_SUPABASE_URL) {
  console.warn(
    '[storefront] STOREFRONT_SUPABASE_URL not set — defaulting to local supabase at http://localhost:54421',
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { persistSession: true, autoRefreshToken: true },
});

/**
 * Helper that wraps queries for multi-policy tables (binders, slab_binders, display_cases,
 * bins, card_skus, card_instances, etc.). RLS unions an anonymous-kiosk policy with a
 * member policy; without an explicit shop_id predicate, a signed-in staff user can see
 * every public-browse row across shops. NEVER use plain `.from(table).select('*')` against
 * these tables — always go through `scoped(table, currentShopId)`.
 *
 * See CLAUDE.md "Critical guardrail #1".
 */
export function scoped(table: string, shopId: string) {
  return supabase.from(table).select('*').eq('shop_id', shopId);
}
